import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { SITE } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsappFab from "@/components/WhatsappFab";
import Home from "@/pages/Home";
import Projetos from "@/pages/Projetos";
import PlanoGoverno from "@/pages/PlanoGoverno";
import Vitrine from "@/pages/Vitrine";
import Trajetoria from "@/pages/Trajetoria";
import Noticias from "@/pages/Noticias";
import NoticiaDetalhe from "@/pages/NoticiaDetalhe";
import Contato from "@/pages/Contato";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import MaintenancePage from "@/pages/MaintenancePage";
import SiteSeguroBadge from "@/components/SiteSeguroBadge";
import ChatWidget from "@/components/ChatWidget";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function Chrome({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  const isMaintenance = pathname === "/" && SITE.maintenanceMode;
  const hideChrome = isAdmin || isMaintenance;
  return (
    <>
      {!hideChrome && <Navbar />}
      {children}
      {!hideChrome && <Footer />}
      {!hideChrome && <WhatsappFab />}
      {!hideChrome && <ChatWidget />}
      {!hideChrome && <SiteSeguroBadge />}
    </>
  );
}

function MaintenanceGate({ children }) {
  // If maintenance mode and route is not /admin/*, redirect to maintenance page.
  const { pathname } = useLocation();
  if (SITE.maintenanceMode && !pathname.startsWith("/admin") && pathname !== "/") {
    return <Navigate to="/" replace />;
  }
  return children;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Chrome>
            <MaintenanceGate>
              <Routes>
                <Route path="/" element={SITE.maintenanceMode ? <MaintenancePage /> : <Home />} />
                <Route path="/projetos" element={<Projetos />} />
                <Route path="/plano-de-governo" element={<PlanoGoverno />} />
                <Route path="/vitrine" element={<Vitrine />} />
                <Route path="/trajetoria" element={<Trajetoria />} />
                <Route path="/noticias" element={<Noticias />} />
                <Route path="/noticias/:slug" element={<NoticiaDetalhe />} />
                <Route path="/contato" element={<Contato />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
              </Routes>
            </MaintenanceGate>
          </Chrome>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
